import { render, staticRenderFns } from "./GrupoNotificacao.vue?vue&type=template&id=75ffa597&scoped=true&"
import script from "./GrupoNotificacao.vue?vue&type=script&lang=js&"
export * from "./GrupoNotificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ffa597",
  null
  
)

export default component.exports